import { memo } from 'react';

import type { LbPart } from '../../types';

const Video = ({ data }) => (
  <div className='card-box-rect'>
    <div className='card-content-wrapper'>
      <div className='card-content'>
        <a href={data.Url} title={data.Title}>
          <article className='article with-picture '>
            {data.ImageUrl && (
              <figure className='article--img-wrap'>
                <picture>
                  <img alt={data.Title} className='picture' src={`${data.ImageUrl}`} />
                </picture>
                <span className='article--overlay'> </span>
              </figure>
            )}
            <div className='article--content'>
              <header className='article--header'>
                <h1 className='article--title'>{data.Title}</h1>
              </header>
              <div className='article--summary'>{data.Comment}</div>
            </div>
            <span className='summary--overlay'> </span>
          </article>
        </a>
      </div>
    </div>
  </div>
);

const Article = ({ data }) => (
  <div className='card-box-rect'>
    <div className='card-content-wrapper'>
      <div className='card-content'>
        <a href={data.Url} title={data.Title}>
          <article className='article with-picture '>
            {data.ImageUrl && (
              <figure className='article--img-wrap'>
                <span className='icon-play'> </span>
                <picture>
                  <img alt={data.Title} className='picture' src={`${data.ImageUrl}`} />
                </picture>
                <span className='article--overlay'> </span>
              </figure>
            )}
            <div className='article--content'>
              <header className='article--header'>
                <h1 className='article--title'>{data.Title}</h1>
              </header>
            </div>
            <span className='summary--overlay'>{data.Description}</span>
          </article>
        </a>
      </div>
    </div>
  </div>
);
const Photo = ({ data }) => (
  <figure className='lb-post--img-wrap'>
    <picture>
      <img alt={data.Title} className='picture' src={`${data.ImageUrl}`} />
    </picture>
  </figure>
);

const UefaEditorial = ({ part: { data } }: { part: LbPart }) => (
  <div className={`lb-fragment-${data.MediaType}`}>
    {(data.MediaType === 'article' || data.MediaType === 'promo') && <Article data={data} />}
    {data.MediaType === 'image' && <Photo data={data} />}
    {data.MediaType === 'video' && <Video data={data} />}
  </div>
);

export default memo(UefaEditorial);
